module.exports = __webpack_public_path__ + "static/media/CHILI.27b8a919.svg";